import { Handshake } from "lucide-react";
import {
  CompactChoiceRow,
  CompactRankSelect,
  DESCRIPTION_INPUT_CLASS,
  FieldLabel,
  FormSection,
  SegmentedChoice,
  ZapPublicationChoice,
  YesNoToggle,
} from "../../../../components/propertyDescription/descriptionUi";
import {
  FLOOR_TYPES,
  PROPERTY_TYPES,
} from "../../../CreateProperty/components/DescriptionForm/constants";
import { PROPERTY_TYPE_ICONS } from "../../../CreateProperty/components/DescriptionForm/propertyTypeIcons";
import { useEditPropertyWizard } from "../EditPropertyWizardContext";
import { HOUSING_PROGRAM_CHOICES } from "../../../../utils/housingProgram";

export default function ClassificationSection() {
  const {
    formErrors,
    propertyType,
    setPropertyType,
    rank,
    setRank,
    isRented,
    setOpenModalDeactivateProperty,
    setOpenModalConfirmActivateProperty,
    setOpenModalEditDeactivateProperty,
    rentData,
    floorType,
    setFloorType,
    housingProgram,
    setHousingProgram,
    zapPublicationType,
    setZapPublicationType,
    yearBuilt,
    setYearBuilt,
    virtualTourUrl,
    setVirtualTourUrl,
  } = useEditPropertyWizard();

  return (
    <FormSection title="Identificação do imóvel">
      <div className="grid grid-cols-1 gap-x-8 gap-y-5 md:grid-cols-[minmax(0,1.75fr)_minmax(0,1fr)]">
        <div className="min-w-0">
          <FieldLabel error={formErrors.property_type_id}>Tipo do imóvel</FieldLabel>
          <CompactChoiceRow
            value={propertyType}
            onChange={setPropertyType}
            options={PROPERTY_TYPES.map((type) => ({
              value: type.value,
              label: type.label,
              icon: PROPERTY_TYPE_ICONS[type.value as keyof typeof PROPERTY_TYPE_ICONS],
            }))}
          />
        </div>
        <div className="min-w-0">
          <FieldLabel>Enquadramento habitacional</FieldLabel>
          <SegmentedChoice
            value={housingProgram}
            onChange={setHousingProgram}
            options={HOUSING_PROGRAM_CHOICES.map((item) => ({
              value: item.value,
              label: item.label,
            }))}
          />
        </div>
      </div>

      <div className="mt-4 grid grid-cols-1 gap-x-8 gap-y-5 md:grid-cols-2">
        <div className="min-w-0">
          <FieldLabel>Tipo de andar</FieldLabel>
          <SegmentedChoice
            value={floorType}
            onChange={setFloorType}
            options={FLOOR_TYPES.map((item) => ({
              value: item.value,
              label: item.label,
            }))}
          />
        </div>
        <div className="min-w-0">
          <FieldLabel error={formErrors.rank}>Nível de destaque</FieldLabel>
          <CompactRankSelect value={rank} onChange={setRank} error={formErrors.rank} />
        </div>
        <div className="min-w-0">
          <FieldLabel error={formErrors.zap_publication_type}>
            Publicação no ZAP
          </FieldLabel>
          <ZapPublicationChoice
            value={zapPublicationType}
            onChange={setZapPublicationType}
          />
        </div>
        <div className="min-w-0">
          <FieldLabel>Está alugado?</FieldLabel>
          <div className="flex items-center gap-2">
            <div className="min-w-0 flex-1">
              <YesNoToggle
                value={!!isRented}
                onChange={(next) => {
                  if (next) setOpenModalDeactivateProperty(true);
                  else setOpenModalConfirmActivateProperty(true);
                }}
              />
            </div>
            {rentData !== null && rentData.rented_by !== null ? (
              <button
                type="button"
                onClick={() => setOpenModalEditDeactivateProperty(true)}
                className="inline-flex h-9 shrink-0 items-center gap-1.5 rounded-md border border-slate-200 px-2.5 text-xs font-medium text-slate-700 hover:bg-slate-50"
              >
                <Handshake className="h-3.5 w-3.5 text-slate-500" aria-hidden />
                Fechamento
              </button>
            ) : null}
          </div>
        </div>
        <div className="min-w-0">
          <FieldLabel>Ano de construção</FieldLabel>
          <input
            type="text"
            value={yearBuilt}
            onChange={(event) => setYearBuilt(event.target.value)}
            className={DESCRIPTION_INPUT_CLASS}
          />
        </div>
        <div className="min-w-0">
          <FieldLabel>Tour virtual (Banib)</FieldLabel>
          <input
            type="text"
            value={virtualTourUrl}
            onChange={(event) => setVirtualTourUrl(event.target.value)}
            placeholder="Link gerado pelo Banib"
            className={DESCRIPTION_INPUT_CLASS}
          />
        </div>
      </div>
    </FormSection>
  );
}
